import React, { useState } from "react";
import { Modal, Button } from "react-bootstrap";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import jwt from "jsonwebtoken";

const Login = (props) => {
  const [loginData, setLoginData] = useState();
  const [loginError, setLoginError] = useState({ state: "hide" });
  const [viewpass, setViewpass] = useState(false);

  let navigate = useNavigate();

  const [user, setUser] = useState({
    googleSignIn: false,
    linkedInSignIn: false,
    name: "",
    email: "",
    photo: "",
    usertype: "",
  });

  const changePassword = (e) => {
    setViewpass(!viewpass);
  };

  const loginFormHandler = (e) => {
    let inputValue = e.target.value;
    setLoginData({
      ...loginData,
      [e.target.name]: inputValue,
    });
    // console.log(loginData);
  };

  const submitLoginForm = (event) => {
    event.preventDefault();
    let form = document.getElementById("loginForm");
    form.classList.add("was-validated");

    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    } else {
      //setLoader(true);
      const body = {
        email: loginData.email,
        password: loginData.password,
      };
      axios
        .post("http://15.206.181.114:4000/api/user/login", body)
        .then((res) => {
          if (res.status === 200) {
            setLoginError({
              message: "Logged in",
              class: "alert-success",
              state: "alert alert-dismissible show",
            });
            jwt.verify(res.data.token, "SecretToken", (err, decoded) => {
              if (err) {
                console.log(err);
              } else {
                localStorage.setItem("user", decoded.userData.firstName);
                localStorage.setItem("userMail", decoded.userData.email);
                localStorage.setItem("userType", decoded.userData.userType);
                localStorage.setItem("token", res.data.token);
                window.location.reload();
              }
            });
          } else {
            setLoginError({
              message: res.data,
              class: "alert-success",
              state: "alert alert-dismissible show",
            });
          }
        });
    }
  };

  return (
    <Modal
      show={props.loginModal}
      onHide={() => {
        props.handleLoginModal();
        setLoginError({
          message: "",
          class: "",
          state: "",
        });
        setLoginData();
      }}
      animation={true}
      className="d-flex align-items-center"
    >
      {/* <Modal.Header closebutton style={{ borderBottom: "0px" }}>
                <Modal.Title>Sign in with</Modal.Title>
            </Modal.Header> */}
      {user.googleSignIn ? (
        <div style={{ textAlign: "center", padding: "0px 50px 50px 50px" }}>
          <img
            src={user.photo}
            alt="Profile"
            width="50px"
            style={{ borderRadius: "50%" }}
          />
          <p>{user.name}</p>
          <p>{user.email}</p>
          {/* <br/>
                    <Button onClick={handleSignOutGoogle} style={{backgroundColor: 'transparent', border: 'none'}}>
                        <img src={logout} alt="Logout" width="100px"/>
                    </Button> */}
        </div>
      ) : (
        <Modal.Body
          closebutton
          style={{ textAlign: "center", padding: "20px" }}
        >
          <h3>Sign In</h3>
          <div
            className={
              "text-left fade " + loginError.state + " " + loginError.class
            }
            role="alert"
          >
            {loginError?.message}
            {/* <button type="button"
                            className="close"
                            data-dismiss="alert"
                            aria-label="Close"
                        >
                            <span aria-hidden="true">&times;</span>
                        </button> */}
          </div>
          <form
            onSubmit={submitLoginForm}
            className="needs-validation w-100"
            id="loginForm"
            noValidate
          >
            <div className="row">
              <div className="form-group text-left col-md-6 col-12">
                <label htmlhtmlFor="loginEmail" className="mb-0">
                  Email address
                </label>
                <input
                  type="email"
                  className="form-control"
                  id="loginEmail"
                  name="email"
                  placeholder="name@example.com"
                  onChange={loginFormHandler}
                  value={loginData ? loginData.email : ""}
                  required
                />
                <div className="invalid-feedback">
                  Please enter correct Email
                </div>
              </div>

              <div className="form-group text-left col-md-6 col-12">
                <label htmlFor="loginPassword" className="mb-0">
                  Password
                </label>
                <input
                  type={viewpass ? "text" : "password"}
                  className="form-control"
                  id="loginPassword"
                  name="password"
                  onChange={loginFormHandler}
                  value={loginData ? loginData.password : ""}
                  required
                />
                <img
                  src={viewpass ? "../../view.png" : "../../private.png"}
                  alt=""
                  style={{
                    height: "20px",
                    position: "absolute",
                    top: "50%",
                    right: "8%",
                  }}
                  onClick={changePassword}
                />
                <div className="invalid-feedback">Please enter Password</div>
              </div>
              <div className="col-12">
                <Button type="submit" className="btn btn-primary px-4">
                  Login
                </Button>
              </div>
            </div>
          </form>
          <h6 className="mt-3">
            If not Registered? Click
            <span
              onClick={props.handleRegisterModal}
              style={{
                color: "#007bff",
                margin: "0px 5px",
                cursor: "pointer",
              }}
            >
              here
            </span>
            to Register.
          </h6>
        </Modal.Body>
      )}
    </Modal>
  );
};

export default Login;
